/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore'
], function(
	_
) {
	'use strict';

	/**
	 * @return the JSON-like object for use in the query (stripped of attributes not relevant to query)
	 */

	class ModelToQueryJSON {
		toQueryJSON (){
			let o = this.toJSON(null, this.queryBlacklistAttrs);

			_.each(_.extend({}, this.nestedCollections, this.nestedModels), (modelClass, modelName) => {
				if(o[modelName]){
					const modelObj = this.get(modelName);
					if(modelObj && modelObj.toQueryJSON){
						const modelQueryJSON = modelObj.toQueryJSON();
						o[modelName] = modelQueryJSON;
					}
				}
			});
			return o;
		}
	}
	return ModelToQueryJSON;
});
